export const ABOUT_PAGE = "/about";
